import React from 'react';
import { userAppContext } from '../../context/Context';
import ProfileData from './ProfileData';
import ProfileFavorites from './ProfileFavorites';
import ProfileApiKey from './ProfileApiKey';
import ProfileHashLinks from './ProfileHashLinks';
import ProfileStickyNotes from './ProfileStickyNotes';
import ProfileSubscriptions from '@/modules/featureBilling/ProfileSubscriptions';
import { useLocation } from 'react-router-dom';
import { isGseaEnabled } from '@/modules/enrichment/helpers';

const ProfileAreaContent: React.FC = () => {
  const { user } = userAppContext();
  const userName = user?.['custom:name'];
  const location = useLocation();

  const isAcademic = user?.['cognito:groups']?.[0] === 'ROLE_ACADEMIC';
  const isTrial = user?.['cognito:groups']?.includes('ROLE_TRIAL');
  const showSubscriptions = isGseaEnabled;

  let hash = location.hash;
  hash = hash === '' ? '#profileData' : location.hash;

  const divContent = id => {
    const divClass = `tab-pane ${hash === '' || hash === '#' + id ? 'active show' : ''} `;
    return divClass;
  };

  const profileDataClass = divContent('profileData');
  const profileFavoritesClass = divContent('favorites');
  const apiKeyClass = divContent('apiKey');
  const stickyNotesClass = divContent('stickyNotes');
  const subscriptionsClass = divContent('subscriptions');

  return (
    <React.Fragment>
      <div className="apply-trial-page">
        <div className="apply-trial-hero-bg" aria-hidden="true">
          <img src="/static/images/KeyVisuals/hero.png" alt="" className="hero-static-image" />
          <div className="hero-video-overlay-profile" aria-hidden="true" />
        </div>
        <div className="apply-trial-content mt-20">
          <div className="home-hero-content-profile">
            <div className="home-hero-section">
              <span
                style={{
                  lineHeight: 1,
                }}
              >
                <h1 className="pt-4">Welcome{userName && `, ${userName}`}</h1>
              </span>
              <div className="row txt-contenido pt-4 pb-4">
                <div className="col-12 col-lg-3 order-0 order-md-0 mb-4 mb-lg-0">
                  <ProfileHashLinks hash={hash} />
                </div>

                <div className="col-12 col-lg-8 order-1 order-lg-1">
                  <div className="tab-content md:ml-5" id="dbInfoTabbedPane">
                    <ProfileData profileDataClass={profileDataClass} />
                    {!isAcademic && !isTrial && <ProfileFavorites favoritesClass={profileFavoritesClass} />}
                    <ProfileApiKey apiKeyClass={apiKeyClass} />
                    <ProfileStickyNotes stickyNotesClass={stickyNotesClass} />
                    {showSubscriptions && <ProfileSubscriptions subscriptionsClass={subscriptionsClass} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProfileAreaContent;
